var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "512.000000pt",
    height: "512.000000pt",
    viewBox: "0 0 512.000000 512.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,512.000000) scale(0.100000,-0.100000)",
    fill: "#000000",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2403 4765 c-349 -63 -668 -298 -830 -611 -103 -199 -133 -345 -133 -649 l0 -212 -112 -5 c-86 -4 -131 -12 -187 -31 -182 -64 -318 -208 -378 -402 -17 -57 -18 -117 -18 -1060 l0 -1000 22 -70 c22 -70 76 -168 123 -222 45 -52 134 -118 197 -146 131 -59 80 -57 1521 -57 1405 0 1396 0 1509 46 150 63 276 199 335 364 l23 65 3 987 c3 1099 5 1065 -65 1207 -46 94 -150 201 -240 249 -87 46 -198 72 -305 72 l-88 0 0 226 c0 189 -3 243 -21 327 -47 236 -158 435 -335 608 -175 169 -377 273 -608 314 -107 18 -312 18 -413 0z m385 -321 c317 -65 576 -317 652 -636 17 -70 20 -118 20 -300 l0 -218 -850 0 -850 0 0 204 c0 297 30 420 141 586 127 188 316 318 534 365 84 19 260 18 353 -1z m1174 -1484 c63 -18 129 -70 162 -130 l31 -55 3 -954 c3 -1095 8 -1028 -81 -1117 -91 -90 21 -84 -1467 -84 -1130 0 -1313 2 -1357 15 -63 19 -133 79 -164 142 l-24 48 0 970 c0 1082 -5 1000 71 1085 37 41 75 66 124 81 39 12 2658 11 2702 -1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2566 2430 c-16 -5 -42 -22 -59 -37 -53 -50 -57 -72 -57 -310 l0 -218 -35 -19 c-51 -28 -112 -98 -143 -164 -23 -49 -27 -70 -27 -152 0 -82 4 -103 27 -152 35 -76 95 -138 170 -179 60 -33 68 -34 168 -34 96 0 110 2 163 29 68 35 150 118 180 183 18 40 22 66 22 153 0 95 -3 110 -27 157 -35 65 -79 116 -135 154 l-43 30 0 220 c0 199 -2 223 -20 258 -32 65 -117 102 -184 81z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLock);
export default __webpack_public_path__ + "static/media/lock.e33954198bae57e16d89604f8994c0fa.svg";
export { ForwardRef as ReactComponent };